import { OciDataService } from './oci-data.service';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { NotificationMessageLevel, NotificationService } from '@lib/core';
import { HttpErrorResponse } from '@angular/common/http';
import { BasketError } from '../lib/types/BasketError';
import { Injectable, inject } from '@angular/core';
import { OciBasketProductDto } from './types/IOciBasketProductDto';

@Injectable({ providedIn: 'root' })
export class OciBackgroundSearchService {
    private readonly ociDataService = inject(OciDataService);
    private readonly notificationService = inject(NotificationService);


    public addOciProductToBasketFromEproc(
        product: OciBasketProductDto,
        catalogId: string,
        quantity: number,
    ): Observable<void> {
        if (product && catalogId && quantity) {
            return this.ociDataService.addOciProductToBasketFromEproc(product, catalogId, quantity).pipe(
                tap(() => {
                    const message = marker('Produkt erfolgreich zum Warenkorb hinzugefügt');
                    this.notificationService.showNotification(message, NotificationMessageLevel.SUCCESS);
                }),
                catchError((error: HttpErrorResponse | BasketError) => {
                    if (error instanceof HttpErrorResponse) {
                        const message = marker('Beim Hinzufügen ist leider ein Fehler aufgetreten');
                        this.notificationService.showNotification(message, NotificationMessageLevel.ERROR);
                    }
                    if (error instanceof BasketError) {
                        const message = marker(
                            'Das Produkt ist leider nicht mit dem Warenkorb kompatibel. Bitte wenden Sie sich an einen Administrator.',
                        );
                        this.notificationService.showNotification(message, NotificationMessageLevel.ERROR);
                    }
                    throw error;
                }),
            );
        }

        return of();
    }
}
